import logo from "./logo.svg";
import "./App.css";
import DubaiProject from "./DubaiProject.jsx";

function App() {
  return (
    <div className="App">
      <DubaiProject />
    </div>
  );
}

export default App;
